import { Box } from "@mui/material";
import CommonBreadCrumb from "components/commonBreadCrumb/CommonBreadCrumb";
import ProfileCard from "components/profileCard/ProfileCard";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
// import VehicleTabList from "./VehicleTabList";
import { useDispatch, useSelector } from "react-redux";

import { vehicleInfo as generateVehicleInfo } from 'pages/vehicle/VehiceData';
import { amenitiesVehicle as aminitiesVehicleInfo } from 'pages/vehicle/VehiceData';

import DriverTablist from "./DriverTabList";
import { getDriver, getMatrixDriver, getTicketDriver, patchUpdateDriver } from "redux/actions/UserDriver";
import useModal from "hooks/useModal";
import { editDriverDialogData } from "./DriverData";
import { getMoreVehicle } from "redux/actions/UserVehicle";

const DriverDetails = () => {

  const dispatch = useDispatch();
  const location = useLocation();
  const { state } = location;
  const {open, toggle} = useModal();
  const [breadcrumb, setBreadCrumb] = useState(null);
  const [defaultValue, setDefaultValue] = useState({});
  const [iconId, setIconId] = useState(null);
  const [value, setValue] = useState('1');

  const driverData = useSelector((state) => state?.userDriver?.userDriver?.data?.body[0])
  const matrixData = useSelector((state) => state?.userMatrixDriver?.userMatrixDriver?.data)
  const ticketData = useSelector((state) => state?.userTicketDriver?.userTicketDriver?.data)
  const moreDetailsData = useSelector((state) => state?.userMoreVehicle?.userMoreVehicle?.data)
  const vehicleInfoData = useSelector((state) => state?.userVehicle?.userVehicle?.data);
  const vehicleMoreData = useSelector((state) => state?.userMoreVehicle?.userMoreVehicle?.data);
  const vehicleMatrixData = useSelector((state) => state?.userMatrixVehicle?.userMatrixVehicle?.data);

  const vehicleInfotable = generateVehicleInfo(vehicleInfoData); 
  const vehicleInfoaminities = aminitiesVehicleInfo(vehicleInfoData);
  const driverVehicleId = driverData?.DriverProfile?.Vehicle?.id

  const tabDetails = {
    matrixData:matrixData,
    ticketData:ticketData,
    moreDetailsData:moreDetailsData,
    vehicleData:vehicleInfoData
  }

  const filterData =  {
    driverId: state?.id,
    status:"",
    page:"",
    pageSize:"",
    date:'',
    duration:'',
    type: 'driver'
  }

  const vehicleComplianceData = {
    submitterId: state?.id,
    submitterType: "driver"
  }

  const breadcrumbPaths = [
    { name: "Drivers", url: "/driver", className: "colorGrey" },
    { name: state?.name, url: "/driver/details", className: "colorGrey" },
  ];

  const subVendorBreadcrumbPaths = [
    { name: "Sub-vendor", url: "/sub-vendor", className: "colorGrey" },
    { name: state?.companyName, url: "/sub-vendor/details", id: state?.subVendorId, companyId: state?.comapnyId, className: "colorGrey" },
    { name: "Drivers", url: "/driver", className: "colorGrey" },
    { name: state?.name, url: "/driver/details", className: "colorPrimary" },
  ]

  useEffect(() => {

    if(Number(location.pathname.split("/")?.length) === Number(3)) {
      setBreadCrumb(breadcrumbPaths);
    }
    else {
      setBreadCrumb(subVendorBreadcrumbPaths);
    }

    dispatch(getDriver(filterData));
    dispatch(getMatrixDriver(filterData));
    dispatch(getTicketDriver(filterData));
    dispatch(getMoreVehicle(vehicleComplianceData));
  }, []);


  const onDialog = (data) => {
    const profileData = {
      driverId:driverData?.id,
      data:{
        "firstName":data?.vendorName,
        "lastName":"",
        "email":data?.email,
        "countryCode":"+91",
        "mobile":data?.number,
        "companyName":"",
        "location":data?.address,
      }
    }

    dispatch(patchUpdateDriver(profileData));
    toggle();
  }

  const onClickStatusIcon = (data) => {
    setDefaultValue(value);
    setIconId(data.id);
   if (data === 'Deactivate') {
      const profileData = {
        driverId: state?.id,
        data: {
          status: 'InActive',
        },
      };
      dispatch(patchUpdateDriver(profileData));
    } else if (data === 'Activate') {
      const profileData = {
        driverId: state?.id,
        data: {
          status: 'Active',
        },
      };
      dispatch(patchUpdateDriver(profileData));
    }
    else if (data === 'Block') {
      const profileData = {
        driverId: state.id,
        data: {
          status: 'Blocked',
        },
      };
      dispatch(patchUpdateDriver(profileData));
    }
    else if (data === 'Unblock') {
      const profileData = {
        driverId: state.id,
        data: {
          status: 'Active',
        },
      };
      dispatch(patchUpdateDriver(profileData));
    }
  };

  const profileObj = {
    details: driverData, 
    open: open, 
    toggle:toggle, 
    onDialog:onDialog, 
    type:"Driver", 
    editDialogData: editDriverDialogData,
    onClickStatusIcon: onClickStatusIcon
  }


  return (
    <Box>
      <CommonBreadCrumb paths={breadcrumb} />
      <ProfileCard profileObj={profileObj} />
       <DriverTablist 
        tabDetails={tabDetails} 
          vehicleInfo={vehicleInfotable} 
          amenitiesVehicle={vehicleInfoaminities}
          driverVehicleId={driverVehicleId}
          vehicleMatrixData={vehicleMatrixData}
          vehicleMoreData={vehicleMoreData}
           />
    </Box>
  );
};

export default DriverDetails;
